export default class SupplyService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getSupplies (params = {}) {
    return new Promise((resolve, reject) => {
      this.$http.get('supplies', { params })
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') {
            const error = new Error(data.message)
            reject(error)
          } else {
            resolve(data)
          }
        })
        .catch(reject)
    })
  }

  createSupply (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('supplies/create', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') {
            const error = new Error(data.message)
            reject(error)
          } else {
            resolve(data.data)
          }
        })
        .catch(reject)
    })
  }

  updateSupply (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`supplies/update/${id}`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') {
            const error = new Error(data.message)
            reject(error)
          } else {
            resolve(data.data)
          }
        })
        .catch(reject)
    })
  }

  deleteOrder (id) {
    return new Promise((resolve, reject) => {
      this.$http.post(`supplies/delete/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') {
            const error = new Error(data.message)
            reject(error)
          } else {
            resolve(data.data)
          }
        })
        .catch(reject)
    })
  }

  closeOrder (id) {
    return new Promise((resolve, reject) => {
      this.$http.post(`supplies/status/close/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') {
            const error = new Error(data.message)
            reject(error)
          } else {
            resolve(data.data)
          }
        })
        .catch(reject)
    })
  }

  saveOrder (id) {
    return new Promise((resolve, reject) => {
      this.$http.post(`supplies/status/save/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') {
            const error = new Error(data.message)
            reject(error)
          } else {
            resolve(data.data)
          }
        })
        .catch(reject)
    })
  }

  sendEmail (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('supplies/email/send/', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') {
            const error = new Error(data.message)
            reject(error)
          } else {
            resolve(data.data)
          }
        })
        .catch(reject)
    })
  }

  receivedItems (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`supplies/receive/${id}`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') {
            const error = new Error(data.message)
            reject(error)
          } else {
            resolve(data.data)
          }
        })
        .catch(reject)
    })
  }

  fetch (id) {
    return new Promise((resolve, reject) => {
      this.$http.get(`supplies/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') {
            const error = new Error(data.message)
            reject(error)
          } else {
            resolve(data.data)
          }
        })
        .catch(reject)
    })
  }

  downloadPurchaseOrderPDF (id) {
    return new Promise((resolve, reject) => {
      this.$http.get(`supplies/${id}/pdf`, {
        responseType: 'blob'
      })
        .then(resolve)
        .catch(reject)
    })
  }
}
